import { DueBillsWidget } from "@/components/transactions/DueBillsWidget";
import { ActiveGoalsWidget } from "@/components/goals/ActiveGoalsWidget";
import type { DueAlert } from "@/hooks/use-due-alerts";

interface DashboardAgendaSectionProps {
  onRefresh: () => void;
  onViewTransaction: (alert: DueAlert) => void;
}

export function DashboardAgendaSection({
  onRefresh,
  onViewTransaction,
}: DashboardAgendaSectionProps) {
  return (
    <div className="space-y-4">
      <DueBillsWidget maxItems={5} onRefresh={onRefresh} onViewTransaction={onViewTransaction} />
      <ActiveGoalsWidget maxItems={3} />
    </div>
  );
}
